// renderMD.ts
import MarkdownIt from 'markdown-it'
import mdFigure from './figure'

const md = new MarkdownIt()
md.use(mdFigure, {
    dataType: true,
    figcaption: true,
    link: false
})

export default md

